module.exports = __webpack_public_path__ + "img/kick-sauber.69d3d424.webp";